import React from 'react';
import {Link} from 'react-router-dom';

import profile from '../imgs/profile.jpg';

class UserAvatar extends React.Component {
  render () {
    let isSm = this.props.size == 'sm'
    let starSize = isSm ? ' fa-xs' : ' fa-lg';
    let avatarSize = isSm ? ' profile-thumbnail-sm' : '';
    let profileSize = isSm ? ' profile-info-sm' : '';
    let containerSize = isSm ? ' profile-container-sm' : '';
    return (
        <div className={`profile-container${containerSize} d-flex`}>
            <Link to="/user/123">
                <div className={`profile-thumbnail${avatarSize}`}>
                    <img src={profile} />
                </div>
            </Link>
            <div className={`profile-info${profileSize}`}>
                <Link className="card-link" to="/user/123">
                    {isSm ? <h5 className="profile-name profile-name-sm">James Warren</h5> : 
                        <h1 className={"profile-name"}>James Warren</h1>}
                </Link>
                <span>
                    <i className={`fas fa-star${starSize}`}></i>
                    <i className={`fas fa-star${starSize}`}></i>
                    <i className={`fas fa-star${starSize}`}></i>
                    <i className={`fas fa-star${starSize}`}></i>
                    <i className={`far fa-star${starSize}`}></i>
                </span>
                <div className="profile-stat">
                    <small>1 {isSm ? "ver" : "verifications"}</small> &middot; <small>23 {isSm ? "rec" : "recommends"}</small>
                </div>
            </div>
        </div>
      )
  }
}

export default UserAvatar;